import type { FC, ReactNode } from 'react'

interface JsonLdProps {
    data: Record<string, unknown> | Record<string, unknown>[]
}

/**
 * Renders a schema.org JSON-LD block. The `<` escape prevents any string
 * content from prematurely closing the script tag.
 */
export const JsonLd: FC<JsonLdProps> = ({ data }): ReactNode => {
    const json = JSON.stringify(data).replace(/</g, '\\u003c')

    return <script type='application/ld+json' dangerouslySetInnerHTML={{ __html: json }} />
}
